/* global window */

export const getStore = () => {
    return (typeof window === 'undefined') ? null : require('../app/store').default;
};
